$( window ).on('load', function() {


  
//  window.sessionStorage

 if (window.location.href.indexOf("geelong") >= 0) {
	sessionStorage.setItem("Location", "G");

   
    $(".website").val('https://www.wheeliegoodwood.com.au/geelong');
 } 
  
 if (window.location.href.indexOf("clyde") >= 0) {
	sessionStorage.setItem("Location", "C");

   
    $(".website").val('https://www.wheeliegoodwood.com.au/pages/wheelie-good-wood-clyde');
 } 

 console.log('test', window.location.href);
  
   if (window.location.href.indexOf("mornington") >= 0) {
	sessionStorage.setItem("Location", "MP");

   
    // $(".website").val('https://www.wheeliegoodwood.com.au/morningtonpeninsula');
    $(".website").val('https://wheeliegoodwood.com.au/collections/mornington-peninsula')
 } 
  
 //click refill from the swap and burn pages
 $('.refillbutton').on('click', function() {
   
    window.sessionStorage
	sessionStorage.setItem("Refill", "Yes");
   
});
 
  
  
var Location = sessionStorage.getItem("Location");
  if (Location == "G"){
    $(".website").val('https://www.wheeliegoodwood.com.au/geelong');
  }
    if (Location == "C"){
    $(".website").val('https://www.wheeliegoodwood.com.au/pages/wheelie-good-wood-clyde');
  }
  if (Location == "MP"){
    // $(".website").val('https://www.wheeliegoodwood.com.au/morningtonpeninsula');

    $(".website").val('https://wheeliegoodwood.com.au/collections/mornington-peninsula');
  }
  console.log(Location);

  
  var Refill = sessionStorage.getItem("Refill");
  if (Refill == "Yes"){
  	console.log('refill');
          $( ".depositno" ).show();
          $( ".deposityes" ).hide();
   
       
        $( ".covidmessage" ).hide();
    
    
    
    
    
    
    
        	$('#refill').removeClass( "btn--secondary-accent" );
     $('#tipoutmesssage').removeClass( "btn--secondary-accent" );
          $('#firstorder').addClass( "btn--secondary-accent" ); 
    
    	   $( "#refill i" ).addClass( "fa-check-square" ).removeClass( "fa-square" );
           $( "#firstorder i" ).removeClass( "fa-check-square" ).addClass( "fa-square" );
    
    
    
  		sessionStorage.setItem("Refill", "");
  }
  
  


  
});

$( '.website' ).change( function() {
  var url = $(this).val();
  
 // console.log(url);
  if (url.indexOf("geelong") >= 0) {
  
    
 	 	sessionStorage.setItem("Location", "G");
 
    
    
    console.log('G');
} else {
    	sessionStorage.setItem("Location", "M");
 	 console.log('M');
}                       
   window.location.href = url;
});



 $('.contact-btn').on('click', function(event) {
      event.preventDefault();
      $(location).attr('href', '/pages/contact-us');
 
 });




window.onload = function(){ 

// Get the modal

var modal = document.getElementById('holdontobinModal');


// Get the button that opens the modal
var btn = document.getElementById("holdontobinBtn");
var subbtn = document.getElementById("subBtn");
var subscriptionBtn = document.getElementById("subscriptionBtn");
// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];
var headermodaltext = document.getElementById("headerforfabric");  
// When the user clicks the button, open the modal 
/* if (typeof(btn) != 'undefined' && btn != null){
  btn.onclick = function() {
  console.log('mode');
  modal.style.display = "block";
}
  } */



// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
    
  
  if (event.target == modal) {
    if (typeof(modal) != 'undefined' && modal != null){
    modal.style.display = "none";
  }
  }
  
}

 var bodyId = document.body.id;


 /* if (bodyId == "refund-deposit-request"){

 // When the user clicks on <span> (x), close the modal
 if (typeof(span) != 'undefined' && span != null){
    span.onclick = function() {
      modal.style.display = "none";
}
}
  console.log('mode');
  modal.style.display = "block";

  }*/


  
  if ((bodyId == "free-cbd-delivery-wheelie-good-wood-melbourne") || (bodyId == "your-shopping-cart") || (bodyId == "wheelie-good-wood-geelong") || (bodyId == "wheelie-good-wood-mornington-peninsula") ) {

       var modal = document.getElementById('summerModal');

          console.log('mode');
       // modal.style.display = "block";



           // When the user clicks on <span> (x), close the modal
       if (typeof(span) != 'undefined' && span != null){
          span.onclick = function() {
            modal.style.display = "none";
      }
      }
    
    
    
  }
  
 // When the user clicks on the button, open the modal
/* subbtn.onclick = function() {

       var modal = document.getElementById('subscriptionModal');

          console.log('mode');
       modal.style.display = "block";



           // When the user clicks on <span> (x), close the modal
       if (typeof(span) != 'undefined' && span != null){
          span.onclick = function() {
            modal.style.display = "none";
      }
      }
    
    
    
  } */
  
  if (typeof(subscriptionBtn) != 'undefined' && subscriptionBtn != null){
  subscriptionBtn.onclick = function() {

       var modal = document.getElementById('subscriptionModal');

          console.log('mode');
       modal.style.display = "block";



           // When the user clicks on <span> (x), close the modal
       if (typeof(span) != 'undefined' && span != null){
          span.onclick = function() {
            modal.style.display = "none";
      }
      }
    
    
    
  }
  }
  
  
}

function headerSize() {
  var $headerHeight = $('div#shopify-section-header').outerHeight();
  $('#PageContainer').css('padding-top', $headerHeight);
}

$(window).on("load", headerSize);
// $(window).on("resize", $.debounce(500, headerSize));